"use client";

import { create } from "zustand";

interface ClaimFlowState {
  selectedWeek: number | null;
  setSelectedWeek: (week: number | null) => void;
}

export const useClaimFlowStore = create<ClaimFlowState>((set) => ({
  selectedWeek: null,
  setSelectedWeek: (week) => set({ selectedWeek: week }),
}));

export const CLAIM_FLOW_SECTION_ID = "cardvault-claim-flow";

export function scrollToClaimFlow() {
  if (typeof document === "undefined") return;
  const el = document.getElementById(CLAIM_FLOW_SECTION_ID);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}
